import OptionsAddedTable from './OptionsAddedTable'
export default OptionsAddedTable
